import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGame";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import { Scale } from 'react-scaling';
import useSpeech from "../../hooks/useSpeech";
import AudioIcon from '../../assets/audio-icon.png'
import { Textfit } from 'react-textfit';




//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer

//var selectedAnswer = -1;
var currQuestion = undefined;

//used for smart allocation - refeed
var refeedQuestions = [];
var repeating = false;
var lastQuestion = "";
var questionCounter = 0;

//Mixes up array
function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
}

//Generates a question from a default question
function GenQuestion(q) {
    let image1 = null;
    let image2 = null;
    let questionText = "";
    let audio2 = "";

    if (q.right_answer.includes(".png")){
        //Fills in the question text complete with generated values
        questionText = q.right_answer.replace(".png","");
        //sort out images
        image1 = q.right_answer;
        image2 = q.wrong_answer_1
        audio2 = q.right_answer.replace(".png","");
    }else{
        //Fills in the question text complete with generated values
        questionText = q.right_answer;
        audio2 = q.wrong_answer_1;
    }

    //Creates an array of answers and fills in the correct answer
    let questionAnswers = [];
    questionAnswers.push({ correct: true, value: q.right_answer, audio: q.audio, image: image1 });
    questionAnswers.push({ correct: false, value: q.wrong_answer_1, audio: audio2, image: image2});

    //Shuffles the answer array
    shuffleArray(questionAnswers);

    //Creates object to return
    let questionObj = {
        question: questionText,
        answers: questionAnswers,
        topic_id: q.topic_id,
        correct: q.right_answer
    };
    console.log(questionObj);

    return questionObj;
}


export default function Practice({ ...props }) {
    const [loading, setLoading] = useState(true);
    const [correctQuestions, setCorrectQuestions] = useState([]);
    const [incorrectQuestions, setIncorrectQuestions] = useState([]);
    const [score, setScore] = useState(0);
    const [combo, setCombo] = useState(0);
    const [maxCombo, setMaxCombo] = useState(0);
    const [feedback, setFeedback] = useState([]);
    const [nofeedback, setNoFeedback] = useState([]);
    const { questions, status } = useTopicQuestions({
        topics: props.topics,
        game_type: props.gameType
    });
    const [selectedAnswer, setSelectedAnswer] = useState(-1);
    const [currentQuestion, setCurrentQuestion] = useState([]);
    //const { sayWord } = useSpeech();

    const[showColouredFeedback, setColouredFeedback] = useState(false);
    const [waitTime, setWaitTime] = useState(-10);

    var timer = -1;
    if(props.timelimit > 0)
    {
        timer = props.timelimit;
    }
    else
    {
        timer = 60;
    }

    var questionMax = -1;
    if(props.minimum > 0)
    {
        questionMax = props.minimum;
    }
     //if question counter is higher than 3 then reset -refeed
    if(questionCounter > 3){
      questionCounter = 0;
  }

  
  //Sets the question to a new one
  function newQuestion() {
        
        currQuestion = GenQuestion(questions[Math.floor(Math.random() * questions.length)]); 

        //Debugging
        /*
        console.log("tst: lastQ: " + lastQuestion);
        console.log("tst: currQ: " + currQuestion.question);
        console.log("tst: Counter: " + questionCounter);
        */


        //get refeed question
        var loop = true;
        if (questionCounter === 2 && refeedQuestions[0] != undefined) {
            repeating = true;
            questionCounter = 0;
            currQuestion = refeedQuestions[refeedQuestions.length - 1];
            loop = false;
        }
        else
        {
            //if current quesiton is same as the previous question then reloop -refeed 
         while(loop){
            if (currQuestion.correct.toString() === lastQuestion.toString()) { 
            //    console.log("tst: I have looped!");
                currQuestion = GenQuestion(questions[Math.floor(Math.random() * questions.length)]); 
            }
            else{
             //  console.log("tst: Good to go!");
               loop = false; 
               break;
		    }
		 }   
        } 
        setSelectedAnswer(-1);
        setCurrentQuestion(currQuestion);
    }

    function reduceTimer() {
        console.log(waitTime);
      setWaitTime(waitTime - 1);
      }

      //When clicking back or leaving the game result reset the array so it doesn't set the question to one from a previous game. -refeed
      function Reset() {
        refeedQuestions = [];
        questionCounter = 0;
        lastQuestion = "";
        console.log("RESET");
    }

      //Called on click
  async function Toggle(value) {
    setSelectedAnswer(value);
    console.log("Selected: " + selectedAnswer)
    sayWord(currentQuestion.answers[value].audio);
    //play sound
  }
  
  function sayWord(word){
    if (word != undefined && word != ""){
        word = word.toLowerCase();
        word = word.replace(".png" ,"");
      console.log("playing sound: " + word);
       var audio = new Audio("/audio/" + word + '.mp3'); 
      audio.play();
      }
    }

    useEffect(() => {
        if (
            currentQuestion !== undefined &&
            currentQuestion.answers !== undefined
        ) {
            const correctAnswer = currentQuestion.answers.filter(answer => {
                return answer.correct === true;
            });
            sayWord(correctAnswer[0].value);
        }
    }, [currentQuestion]);

  function ReturnButton(value) {
    if (currentQuestion.answers[value].image == null){
            if (value == selectedAnswer) {
            return (
                <SelectedButton
                value={currentQuestion.answers[value].value}
                style={{ flex: 1, margin: "20px" }}
                onClick={() => Toggle(value)}
                >
                <img style={{ position: "relative", top: "15%" }} src={AudioIcon} />
                </SelectedButton>
            );
            } else {
            return (
                <Button
                value={currentQuestion.answers[value].value}
                style={{ flex: 1, margin: "20px" }}
                onClick={() => Toggle(value)}
                >
                <img style={{ position: "relative", top: "15%" }} src={AudioIcon} />
                </Button>
            );
            }
        }else{
            if (value == selectedAnswer) {
                return (
                    <SelectedButton
                    value={currentQuestion.question}
                    style={{ flex: 1, margin: "20px" }}
                    onClick={() => Toggle(value)}
                    >
                    {/* Updated image source to reference the public folder */}
                    <img style={{ position: "relative", top: "15%",width: "150px" }} src={`/qimages/phonics/${currentQuestion.answers[value].image}`} />
                    </SelectedButton>
                );
                } else {
                return (
                    <Button
                    value={currentQuestion.question}
                    style={{ flex: 1, margin: "20px" }}
                    onClick={() => Toggle(value)}
                    >
                    {/* Updated image source to reference the public folder */}
                    <img style={{ position: "relative", top: "15%",width: "150px" }} src={`/qimages/phonics/${currentQuestion.answers[value].image}`} />
                    </Button>
                );
        }
    }
  }

  function ReturnFeedbackButton(value) {

    if (currentQuestion.answers[value].image == null){
      return (
        <Button
          value={currentQuestion.answers[value].value}
          style={{ flex: 1, margin: "20px" , ...(currentQuestion.answers[value].correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
        >
          <span>{<div dangerouslySetInnerHTML={{ __html: (currentQuestion.answers[value].value) }} />}</span>
        </Button>
      );
      }else{
        return (
            <Button
              value={currentQuestion.question}
              style={{ flex: 1, margin: "20px" , ...(currentQuestion.answers[value].correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
            >
            {/* Updated image source to reference the public folder */}
              <img style={{ position: "relative", top: "15%",width: "150px" }} src={`/qimages/phonics/${currentQuestion.answers[value].image}`} />
            </Button>
          );
      }
  }

    async function checkResult() {
        if(showColouredFeedback == false)
        {
        if (selectedAnswer == -1){
            return;
        }

         //set the current question to the last question -refeed
        questionCounter = questionCounter +1;
        lastQuestion = currQuestion.correct;

        var isCorrect = false;
        var count = 0;
        var selected = "";
        if (currentQuestion.answers[selectedAnswer].value == currentQuestion.correct){
            isCorrect = true;
        }else{
            isCorrect = false;
            questionCounter = 0;
        }
            if (isCorrect) {
                setCorrectQuestions([...correctQuestions, currentQuestion]);
                let multiplier = combo > 0 ? combo + 1 : 1;
                multiplier = multiplier > 5 ? 5 : multiplier;
                setScore(score + multiplier * 10);

                if (combo < 99) {
                    setCombo(combo + 1);
                }
                if (combo > maxCombo) {
                    setMaxCombo(combo);
                }
                //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
                if (repeating) {
                    refeedQuestions.pop();
                    repeating = false;
                }

                let result = {
                    question: currQuestion.question,
                    correct: currQuestion.correct,
                    incorrect: currentQuestion.answers[selectedAnswer].value
                };
                setNoFeedback([...nofeedback, result]);

                newQuestion();
            }
            //incorrect answer
            else {
                isCorrect = false;
                //push question to refeed if user gets it wrong - refeed
                refeedQuestions.push(currQuestion);

                setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
                if (combo === 0 && score >= 10) {
                    setScore(score - 10);
                } else {
                    setCombo(0);
                }
                let result = {
                    question: currQuestion.question,
                    correct: currQuestion.correct,
                    incorrect: currentQuestion.answers[selectedAnswer].value
                };

                setFeedback([...feedback, result]);
                setColouredFeedback(true);
                setWaitTime(2);
            }

            //Generates a new question
            //newQuestion();
    }
    }
    useEffect(() => {
        if (waitTime > 0) {
            var waitttimerID = setInterval(() => reduceTimer(), 1000);
            return () => {
                clearInterval(waitttimerID);
            };
        } else if (waitTime != -10){
    
            setColouredFeedback(false);
            newQuestion();
        }
      },[waitTime]);

    //Set the first question, called until questions are defined
    useEffect(() => {
        if (questions !== undefined) {
            var sample = GenQuestion(questions[Math.floor(Math.random() * questions.length)]); 
            currQuestion = sample;
            setCurrentQuestion(sample);
        }
    }, [questions]);

    //No clue
    useEffect(() => {
        if (status !== undefined && status === "OK") {
            setLoading(false);
        }
    }, [status]);

    function ComboImage() {
        console.log(props);
        let comboNum = combo;
        if (combo > 4)
            comboNum = 4;
        var imageName = props.gameData.animation_path + "/combo" + comboNum + ".png";
        //return <img src= {{imageName}} style={{position:"relative"}}></img>
        console.log("../../assets/" + imageName)

        return (require("../../assets/" + imageName))

    }
    console.log(currentQuestion);
    console.log(currQuestion);

    //I don't know how to comment html/CSS
    return (
        <>
            <PracticeGame
                parent={props}
                correct={correctQuestions}
                incorrect={incorrectQuestions}
                score={score}
                defaultTimer={timer}
                questionLimit={questionMax}
                onBack={() => {
                Reset();
                props.onBack();
                }}
                loading={loading}
                feedback={feedback}
                nofeedback={nofeedback}
                questionFontSize="0.7em"
                restart={() => {
                    setCombo(0);
                    setScore(0);
                    setCorrectQuestions([]);
                    setIncorrectQuestions([]);
                    Reset();
                }}
            >
                <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
                    <Scale scaleTo={1720}>
                        <Body>
                            <div>{currQuestion !== undefined ? (


                                <Container>
                                    <div>
                                        <div style={{ display: "flex", flexDirection: "row" }}>
                                            <Question
                                                type="text"
                                                disabled
                                                value={
                                                    currentQuestion.question !== undefined
                                                        ? currentQuestion.question.replace("$", "?")
                                                        : ""
                                                }
                                            >
                                                <Textfit mode="multi" max="50" style={{ height: "100%" }}><span>{<div dangerouslySetInnerHTML={{ __html: (currentQuestion.question) }} />}</span></Textfit></Question>
                                        </div>
                                        {currentQuestion.question2 !== undefined && currentQuestion.question2 !== "" ?
                                            <Question
                                                type="text"
                                                disabled
                                                value={
                                                    currentQuestion.question2 !== undefined
                                                        ? currentQuestion.question2.replace("$", "?")
                                                        : ""
                                                }
                                            ><Textfit mode="multi" max="40" style={{ height: "100%" }}><span>{<div dangerouslySetInnerHTML={{ __html: (currentQuestion.question2) }} />}</span></Textfit></Question>
                                            : ""}
                                    </div>
                                    {showColouredFeedback == false && currentQuestion.answers !== undefined ? (
                                        <div>
                                            <div
                                                selected={selectedAnswer}
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between"
                                                }}
                                            >
                                                {ReturnButton(0)}
                                                {ReturnButton(1)}
                                            </div></div>) : ""}

                                            {showColouredFeedback == true && currentQuestion.answers !== undefined ? (
                                        <div>
                                            <div
                                                selected={selectedAnswer}
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    justifyContent: "space-between"
                                                }}
                                            >
                                                {ReturnFeedbackButton(0)}
                                                {ReturnFeedbackButton(1)}
                                            </div></div>) : ""}

                                    <LongButton
                                        style={{ alignSelf: "center", flex: 1, margin: "20px" }}
                                        onClick={() => checkResult()}
                                    >
                                        <span>Submit</span>
                                    </LongButton>
                                </Container>

                            ) : <h1></h1>}
                            </div>
                            <Combo>
                                <span style={{ fontSize: "50px" }}>{combo}</span>
                                <span style={{ fontSize: "20px" }}>COMBO</span>
                            </Combo>
                        </Body>
                    </Scale>
                </div>
            </PracticeGame>
        </>
    );
}

const Body = styled.div`
            width: 100%;
            height: 100%;
  background-image: url("${props => props.gameBackground}");
            background-size: cover;
            background-position: 0px -1px;
            display: flex;
            justify-content: center;
            padding-top: 40px;
          `;

const Result = styled.div`
            width: 100%;
            height: 100%;
            font-size: 5em;
            text-align: center;
            border: solid 2px #683d8c;
          `;

const Combo = styled.div`
            background: #4391bb;
            width: 120px;
            height: 120px;
            border-radius: 75px;
            border: solid #204b7b 4px;
            display: flex;
            flex-direction: column;
            text-align: center;
            color: #fff;
            justify-content: center;
            font-weight: 600;
            margin-left: 50px;
          `;

const Container = styled.div`
          width:100%
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-bottom:100px;
          `;

const Question = styled.div`
            background: #FFF;
            user-select: none;
            width: 1000px;
            height: 100%;
            line-height: 50px;
            font-size: 4em;
            margin: 5px 0px;
            text-align: center;
            font-weight: 600;
            border: none;
            border-radius: 10px;
            padding: 0.5em;
            margin-bottom: 2%;
          `;

const Button = styled.div`
            text-align: center;
            width: 10%;
            height: 100%;
            line-height: 40px;
            font-size: 4em;
            margin: 0px;
            color: #fff;
            user-select: none;
            background: rgb(234, 146, 19);
            background: linear-gradient(
              0deg,
              rgba(234, 146, 19, 1) 0%,
              rgba(255, 186, 32, 1) 100%
            );
            border: 2px solid #e88f12;
            padding: 0.5em;
            box-sizing: border-box;
            border-radius: 0.25em;
            cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
        font - size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin - bottom: 0;
  }
  margin-bottom: 1.5%;
`;

const SelectedButton = styled.div`
    text-align: center;
    width: 10%;
    height: 100%;
    line-height: 40px;
    font-size: 4em;
    margin: 0px;
    color: #fff;
    user-select: none;
    background: rgb(45, 168, 35);
    background: linear-gradient(
      0deg,
      rgba(45, 168, 35, 1) 0%,
      rgba(36, 138, 29, 1) 100%
    );
    border: 2px solid #1d7d16;
    padding: 0.5em;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
        font - size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin - bottom: 0;
  }
  margin-bottom: 1.5%;
`;
const LongButton = styled.div`
  text-align: center;
  width: 80%;
  height: 100px;
  line-height: 50px;
  font-size: 4em;
  margin: 5px;
  color: #fff;
  user-select: none;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  border: 2px solid #e88f12;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;